import { CartLineItemGiftDetails } from 'common/api/e-comm/models/CartLineItem';
import { BulkOrderState, Recipient } from './BulkOrderContext';
import { BulkOrderCartItem } from 'common/api/e-comm/models/CartItem';
import { addItemsToCart } from 'common/api/e-comm/cart/lineitem';

export const convertBulkOrderStateToCartItem = (
    state: BulkOrderState,
    productId: number,
    amount: Pick<BulkOrderCartItem, 'priceOverride' | 'selectedOptions'>
): BulkOrderCartItem => {
    const giftDetails: CartLineItemGiftDetails[] = state.recipients.map((recipient: Recipient) => ({
        fromName: state.senderName || '',
        fromPhone: null,
        toName: recipient.name,
        toEmail: recipient.email,
        deliveryDate: state.deliveryDate?.toISOString() || '',
        message: state.message,
        productImageName: state.selectedCardDesign?.ImageName || '',
    }));

    const cartItem: BulkOrderCartItem = {
        ...amount,
        productId,
        quantity: 1,
        giftDetails: giftDetails,
    };

    return cartItem;
};

export async function addToCart(
    state: BulkOrderState,
    productId: number,
    amount: Pick<BulkOrderCartItem, 'priceOverride' | 'selectedOptions'>
) {
    const formattedPayload = convertBulkOrderStateToCartItem(state, productId, amount);
    return await addItemsToCart(formattedPayload);
}
